export const MONTH_NAMES = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

export const WEEKDAY_SHORT = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export const groupDatesByMonth = (data) => {
  return data.reduce((acc, item) => {
    const key = `${item.y}-${item.m}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});
};

export const generateMonthDays = (year, month) => {
  const daysInMonth = new Date(year, month, 0).getDate();
  const firstDayOfWeek = new Date(year, month - 1, 1).getDay();
  const offset = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

  return Array(offset)
    .fill(null)
    .concat(Array.from({ length: daysInMonth }, (_, i) => i + 1));
};

export const filterAvailableDates = (items, allowedLengths) =>
  items.filter((item) => {
    const lengthsArray = item.lengths.split(', ').map((length) => Number(length.trim()));
    return allowedLengths.every((length) => lengthsArray.includes(length));
  });
